import React from 'react';

import Layout from '../../Layout/index';
import NewsList from '../../NewsList/index';


const Fashion = () => {
    return (
        <Layout title="Fashion News - Bull & Bear">
            <NewsList category="fashion" />
        </Layout>
    )
};

export default Fashion;